import * as React from "react"
import { Line } from "@reactchartjs/react-chart.js"
import { useSelector } from "react-redux"
import { AppState } from "../../../store/types"
import { useRef } from "react"

export default function BigChart() {
  if (typeof window !== "undefined") {
    // this mess needs to be here because chartjs-plugin-zoom uses hammer, which use window... still 4 year old open issue on github
    // https://github.com/hammerjs/hammer.js/issues/930
    require("chartjs-plugin-zoom")
    const { fullYearLocationData } = useSelector(
      (state: AppState) => state.devDocs
    )

    const chartRef = useRef(null)
    const resetZoom = () => {
      if (chartRef !== null && chartRef.current !== null) {
        chartRef.current.resetZoom()
      }
    }

    const maxPercentage = Math.max(
      ...fullYearLocationData.map(x => x.percentage)
    )
    const minPercentage = Math.min(
      ...fullYearLocationData.map(x => x.percentage)
    )

    const data = {
      labels: fullYearLocationData.map(x => x.dateTime),
      datasets: [
        {
          borderWidth: 2,
          label: "Estimated Relative Availability",
          data: fullYearLocationData.map(
            x =>
              ((x.percentage - minPercentage) /
                (maxPercentage - minPercentage)) *
              100
          ),
          fill: false,
          borderColor: "#EC1300",
          pointRadius: 1,
        },
      ],
    }

    const options = {
      responsive: true,
      pan: {
        enabled: true,
        mode: "x",
      },
      zoom: {
        enabled: true,
        mode: "x",
      },
      scales: {
        yAxes: [
          {
            ticks: {
              display: true,
            },
            scaleLabel: {
              display: true,
              labelString: "Estimated Relative Availability",
            },
          },
        ],
        xAxes: [
          {
            type: "time",
            time: {
              displayFormats: {
                hour: "MMM D HH:mm",
              },
            },
            ticks: {
              display: true,
            },
            scaleLabel: {
              display: true,
              labelString: "Datetime",
            },
          },
        ],
      },
      legend: {
        display: true,
      },
    }

    if (fullYearLocationData.length === 0) {
      return <></>
    }

    return (
      <>
        <h2>Year Chart Data</h2>
        <Line ref={chartRef} type="line" data={data} options={options} />
        <button onClick={resetZoom}>Reset Zoom</button>
      </>
    )
  }

  return <></>
}
